module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_reports-f6a6b59610bd3f33c7a9d83d4d78a2a4.jpg";